<template>
  <div
    class="w-full max-w-md bg-white z-40 shadow-lg rounded-lg ring-1 pointer-events-auto ring-black/5"
    :class="{ 'cursor-pointer': data.url }"
    @click="open"
  >
    <div class="p-4">
      <div class="flex items-start">
        <div class="shrink-0">
          <component :is="icon" :class="`h-6 w-6 text-${color}-400`" />
        </div>
        <div class="ml-3 w-0 flex-1 pt-0.5">
          <p class="text-sm text-gray-900">
            {{ data.message }}
          </p>
        </div>
        <div v-if="!data?.needs_reload" class="ml-4 shrink-0 flex">
          <button
            class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            @click.stop="close"
          >
            <SolidXIcon class="h-5 w-5" />
          </button>
        </div>
      </div>
      <t-button
        v-if="data?.needs_reload"
        leading-icon="SolidUploadIcon"
        type="primary"
        class="mt-2"
        @click="reload"
      >
        Charger la nouvelle version
      </t-button>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import useRequest from '@/api/useRequest'

const colors = {
  error: 'red',
  warning: 'yellow',
  info: 'blue',
  success: 'green',
}
const icons = {
  error: 'SolidXCircleIcon',
  warning: 'SolidExclamationIcon',
  info: 'InformationCircleIcon',
  success: 'SolidCheckCircleIcon',
}
export default {
  name: 'NotificationPopUp',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const color = computed(() => {
      return colors[props.data.status]
    })
    const icon = computed(() => {
      return icons[props.data.status]
    })
    const { post } = useRequest()
    return {
      color,
      icon,
      post,
    }
  },
  methods: {
    async markAsRead() {
      if (await this.post(`notifications/${this.data.id}/`)) {
        this.close()
        this.$root.decrementNotifications()
      }
    },
    async open() {
      if (this.data?.needs_reload) {
        return
      }
      await this.markAsRead()
      this.$inertia.get(this.data.url)
    },
    close() {
      this.$root.removeNotification(this.id)
    },
    reload() {
      window.location.reload()
    },
  },
}
</script>
